import React, { useState } from "react";
import { Info, ShieldCheck } from "lucide-react";

const PRETTY_SCOPE = {
  energielabel: "energielabel",
  eigendomsakte: "eigendomsakte",
  vve_balans: "VvE-balans",
  vragenlijst: "vragenlijst",
  meetrapport: "meetrapport",
  plattegronden: "plattegronden",
};

/**
 * Subtiele notice voor particulier-advertenties:
 * - 1 regel, grijze tekst, info-icoontje. Geen alarmkleur.
 * - Toont een aparte chip "Documenten professioneel gecontroleerd" alleen
 *   wanneer document_check_status indicates a positive check.
 *
 * Verplicht per Terms v2.0 §A6-A7. Zie TERMS_V2_DRAFT.md.
 */
export const PrivateSellerNotice = ({ listing, className = "" }) => {
  const [showDetails, setShowDetails] = useState(false);
  if (!listing || listing.seller_type !== "particulier") return null;

  const checkStatus = listing.document_check_status;
  const positiveCheck = checkStatus === "checked" || checkStatus === "issues_found";
  const scope = (listing.document_check_scope || []).map((s) => PRETTY_SCOPE[s] || s);
  const checkDate = listing.document_check_date
    ? new Date(listing.document_check_date).toLocaleDateString("nl-NL", { day: "numeric", month: "long", year: "numeric" })
    : null;

  return (
    <div className={`space-y-2 text-xs leading-relaxed text-slate-500 ${className}`} data-testid="private-seller-notice">
      <p className="flex items-start gap-1.5">
        <Info size={13} className="mt-0.5 shrink-0 text-slate-400" />
        <span>
          Aangeboden door een particuliere verkoper. WoningAlert baseert de woninginformatie op gegevens die door de verkoper zijn aangeleverd — controleer belangrijke informatie en documenten vóór je een koopbeslissing neemt.
        </span>
      </p>

      {positiveCheck && (
        <>
          <button
            type="button"
            onClick={() => setShowDetails((v) => !v)}
            className="inline-flex items-center gap-1.5 rounded-full bg-success/10 px-2.5 py-1 text-[11px] font-semibold text-success hover:bg-success/15"
            data-testid="doc-check-chip"
          >
            <ShieldCheck size={12} /> Documenten professioneel gecontroleerd
          </button>
          {showDetails && (
            <div className="mt-1 rounded-xl border border-success/20 bg-success/5 p-3 text-[11px] text-slate-600">
              {checkDate && <div><strong>Gecontroleerd op:</strong> {checkDate}</div>}
              {scope.length > 0 && <div><strong>Scope:</strong> {scope.join(", ")}</div>}
              {listing.document_check_provider && (
                <div><strong>Door:</strong> {listing.document_check_provider}</div>
              )}
              <div className="mt-2 text-slate-500">
                Deze controle is geen garantie dat de documenten volledig juist zijn en vervangt geen eigen onderzoek of advies van een notaris/aankoopmakelaar.
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default PrivateSellerNotice;
